import { ReducerFunctions } from "../../utils";
import { Categories, AddCategories, DeleteCategories, CategoriesStatus, AccountTxns } from "./categories";

export const categories_reducer = ReducerFunctions(Categories, {});
export const categories_status_reducer = ReducerFunctions(CategoriesStatus, {});
export const add_categories_reducer = ReducerFunctions(AddCategories, {});
export const delete_categories_reducer = ReducerFunctions(DeleteCategories, {});
export const account_txns_reducer = ReducerFunctions(AccountTxns, {});